module.exports = "<title>MI Smart Simulator</title>\n\n<!-- <sh-page theme=\"dark\">\n  <sh-access-bar label=\"Welcome to MI Simulator\" slot=\"access\">\n    <sh-icon button icon=\"menu\" slot=\"left\"></sh-icon>\n    \n  </sh-access-bar> -->\n\n<!-- <div style=\"width: 100%; height: 100%;\"> -->\n  <!-- <sh-card label='' card-height='100%'> -->\n    <router-outlet></router-outlet>\n    <!-- {{env.url}} -->\n  <!-- </sh-card> -->\n<!-- </div> -->\n\n<!-- </sh-page> -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main